<template>
	<div class="order-search-body">
		<div class="advance-search">
			<div class="filters-box-row">
				<div class="filters-container">
					<div class="input-box">
						<el-input
							class="search-input"
							prefix-icon="el-icon-search"
							v-model="keyword"
							placeholder="客户名称/客户编号/手机号/注册码"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span class="input-title">客户等级：</span>
						<el-select v-model="customerlevelid" class="filter-input" size='small'>
							<el-option value="0" label="全部"></el-option>
							<el-option v-for="(item,index) in levelList" :key='index' :value="item.customerlevelid" :label="item.customerlevelname"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span class="input-title">客户类别：</span>
						<el-select v-model="customercategoryid" class="filter-input" size='small'>
							<el-option value="0" label="全部"></el-option>
							<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span class="input-title">启用状态：</span>
						<el-select v-model="disabledflag" class="filter-input" size='small'>
							<el-option :value="''" label="全部"></el-option>
							<el-option :value="0" label="启用"></el-option>
							<el-option :value="1" label="停用"></el-option>
						</el-select>
					</div>
				</div>
				<!-- <div class="filters-container">
					<div class="input-box">
						<span>客户名称：</span>
						<el-input
							class="search-input"
							v-model="customer"
							placeholder="请输入客户名称/编号"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div> -->
				<div class="filters-container">
					<div class="input-box">
						<span>{{premoneytype === 0 ? '可用预付货款' : '预付货款金额总计'}}：</span>
						<div class="money-box">
							<el-select v-model="premoneytype" class="select-input" size='small'>
								<el-option :value="0" label="可用预付货款"></el-option>
								<el-option :value="1" label="预付货款金额总计"></el-option>
							</el-select><span style="color:#DBDBDB;">丨</span>
							<el-input
								class="inventory-input"
								v-model="minmoney"
								placeholder="最小值"
								size="small"
								@input="orderInput"
								@keyup.enter.native="search">
							</el-input>
							<span style="margin: 0 5px">——</span>
							<el-input
								class="inventory-input"
								v-model="maxmoney"
								placeholder="最大值"
								size="small"
								@input="orderInput2"
								@keyup.enter.native="search">
							</el-input>
						</div>
					</div>
				</div>
			</div>
			<div class="advance-search-btn">
				<!-- <el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button> -->
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="search-btn-box" v-if="AuthorityList['04_0002_0002_00']">
			<div style="height:60px;display:flex;align-items: center;">
				<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" @click="muitlSet">充值</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" @click="fixedAmountRecharge">固定金额充值设置</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" @click="exportExcel" v-if="prepaymentdefaultaccount !== 0">
					<div></div>
					导出
				</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" @click="exportExcelByfront" v-else>
					<div></div>
					导出
				</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn" @click="downloadFile">
					下载批量充值模板
				</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn" @click="importPriceExcel">
					导入批量充值
				</el-button>
				<input type="file" ref="file" id="file" accept=".xls,.xlsx" v-show="false" @change="getFile">
			</div>
			<div v-if="prepaymentdefaultaccount === 1" style="margin-right:20px">数据来源提供：云供应链</div>
		</div>
		<el-dialog
				title="预付货款账户切换提示"
				:visible.sync="tipModel"
				class="tip-modal"
				:close-on-click-modal="false"
				width="500px">
					<div style="display:flex;flex-direction: column;text-align: left;">
						<div class="title">充值功能已停用</div>
						<div class="content">1、当前预付货款数据来源为：云供应链</div>
						<div class="content"> 2、为了保证数据准确，请前往‘云供应链’系统进行充值操作</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="cancelClick">已了解</el-button>
					</span>
			</el-dialog>
		<el-dialog
			:title="'批量充值 (已勾选' + ids.length + '个客户)'"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="500px"
			:close-on-click-modal="false">
			<div>
				<div class="dialog-charge-content">
					<div>
						<span class="dialog-name">充值方式：</span>
						<div class="dialog-readonly">线下支付</div>
					</div>
					<div>
						<span class="dialog-name">充值金额：</span>
						<div class="per-money">
							<span class="per-tag">￥</span>
							<el-input class="per-input" v-model="percentValue" @input="percentInput" size="small"></el-input>
						</div>
						<el-tooltip class="item" effect="light" content="当前买家账户向卖家充值的货款金额！" placement="top-start">
							<img src="~/images/icon/tooltip-icon.png" style="cursor:pointer;">
						</el-tooltip>
					</div>
					<div v-if="showgift === 1">
						<span class="dialog-name">赠送金额：</span>
						<div class="per-money">
							<span class="per-tag">￥</span>
							<el-input class="per-input" v-model="giftMoney" @input="giftMoneyInput" size="small"></el-input>
						</div>
					</div>
				</div>
				<div style="text-align:right;margin-top: 30px;">
					<el-button class="btn" size="small" plain @click="close">取消</el-button>
					<el-button class="btn" size="small" type="primary" @click="multiSave">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="固定金额充值设置"
			:visible.sync="fixedAmountDialogVisible"
			class="dialog-title"
			width="680px"
			:before-close="closeAmountDialog"
			:close-on-click-modal="false">
			<div>
				<div class="amount-box">
					<div class="long-span-box">
						<el-checkbox v-model="isFixedAmountFlag"></el-checkbox>
						开启固定金额设置
					</div>
					<div v-if="isFixedAmountFlag">
						<div v-for="(item, index) in amountList" :key="index" class="content">
							<div style="margin-left: 20px;">
								设置<span style="font-weight:bold;">【充值】</span>金额<el-input v-model="item.amount" size="mini" style="width: 110px;margin:0 10px;" @input="checkNum(item.amount, index)"></el-input>元
							</div>
							<div style="margin-left: 40px;" v-if="showgift === 1">
								设置<span style="font-weight:bold;">【赠送】</span>金额<el-input v-model="item.giftAmount" size="mini" style="width: 110px;margin:0 10px;" @input="checkNum(item.giftAmount, index)"></el-input>元
							</div>
							<i class="el-icon-remove" v-if="item.canDelete" @click="deleteMount(index)"></i>
						</div>
						<div class="add-btn" v-if="isFixedAmountFlag && !disabledAddFlag" @click="addMount">+ 添加固定金额设置组</div>
					</div>
				</div>
				<div style="text-align:center;margin-top: 30px;">
					<el-button class="btn" size="small" type="primary" @click="saveAmountSetting">保存</el-button>
					<el-button class="btn" size="small" plain @click="closeAmountDialog">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="padding-bottom:20px;text-align: left;overflow:auto" v-for="item in tipData" :key="item">
				{{item}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		tableData: {
			type: Array
		},
		ids: {
			type: Array,
			default: () => []
		},
		customList: {
			type: Array,
			default: () => []
		},
		lineList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		},
		orderKey: {
			type: String
		},
		orderBy: {
			type: String
		},
		needauditingflag: Boolean,
		prepaymentdefaultaccount: {
			type: Number,
			default: 0
		},
		showgift: {
			type: Number,
			default: 1
		}
	},
	data () {
		return {
			tipData: [],
			tipModal: false,
			batchDialogVisible: false,
			batchFile: null,
			batchFileName: '',
			tipModel: false,
			collapse: false,
			dialogVisible: false,
			methodValue: 2,
			percentValue: '',
			giftMoney: '0',
			shopCategoryBigId: '0',
			shopCategorySmallId: '0',
			bc: [],
			sc: [],
			disabledflag: '',
			keyword: '',
			customer: '',
			product: '',
			spec: '',
			customerlevelid: '0',
			levelList: [],
			customercategoryid: '0',
			minmoney: '',
			maxmoney: '',
			premoneytype: 0,
			isFixedAmountFlag: false,
			fixedAmountDialogVisible: false,
			disabledAddFlag: false,
			amountList: [
				{
					amount: '',
					giftAmount: '',
					canDelete: false,
					checked: false
				}
			],
			amountArr: [],
			ruleForm: {},
			excelParams: {},
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			excelCol: [{
				label: '客户名称',
				prop: 'customerName',
				align: 'center'
			}, {
				label: '客户编号',
				prop: 'customerCode',
				align: 'center'
			}, {
				label: '客户状态',
				prop: 'disabledflag',
				align: 'center'
			}, {
				label: '客户等级',
				prop: 'customerlevelname',
				align: 'center'
			}, {
				label: '客户类别',
				prop: 'customerCategoryName',
				align: 'center'
			}, {
				label: '可用预付货款',
				prop: 'usablepremoney',
				align: 'center'
			}, {
				label: '预付货款总计',
				prop: 'premoney',
				align: 'center'
			}, {
				label: '可用充值金额',
				prop: 'usAbleCostPreMoney',
				align: 'center'
			}, {
				label: '可用赠送金额',
				prop: 'usAbleGiftPreMoney',
				align: 'center'
			}, {
				label: '充值金额统计',
				prop: 'costPreMoney',
				align: 'center'
			}, {
				label: '赠送金额统计',
				prop: 'giftPreMoney',
				align: 'center'
			}],
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('payAdvanceSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('payAdvanceSelect'))
			this.customerlevelid = data.customerlevelid
			this.customercategoryid = data.customercategoryid
			this.disabledflag = data.disabledflag
			this.keyword = data.keyword
			this.minmoney = data.minmoney
			this.maxmoney = data.maxmoney
			this.premoneytype = data.premoneytype
		}
		this.getLevelList()
	},
	methods: {
		importPriceExcel () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile (e) {
			this.uploadGoodsHandle()
			this.$refs.file.value = ''
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/customer/importCustomerPrePayment`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.search()
					} else {
						this.tipData = res.data
						this.tipModal = true
					}
				})
			})
		},
		downloadFile () {
			let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/biubiuorder/orderprepayment/template/批量预充值.xlsx' + '?timestamp=' + new Date().getTime()
			window.location.href = url
		},
		cancelClick () {
			this.tipModel = false
		},
		// 余额输入
		orderInput () {
			this.minmoney = this.minmoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.minmoney = this.minmoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.minmoney = this.minmoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.minmoney = this.minmoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.minmoney = this.minmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		},
		orderInput2 () {
			this.maxmoney = this.maxmoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.maxmoney = this.maxmoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.maxmoney = this.maxmoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.maxmoney = this.maxmoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.maxmoney = this.maxmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		},
		getLevelList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerLevelList`
			}).then(res => {
				res.data.forEach(e => {
					e.checked = false
				})
				this.levelList = res.data
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		percentInput () {
			this.percentValue = this.percentValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.percentValue = this.percentValue.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.percentValue = this.percentValue.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			if (+this.percentValue >= 10000000) {
				this.percentValue = this.percentValue.substring(0, 7)
			} else {
				this.percentValue = this.percentValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		giftMoneyInput () {
			this.giftMoney = this.giftMoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.giftMoney = this.giftMoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.giftMoney = this.giftMoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			if (+this.giftMoney >= 10000000) {
				this.giftMoney = this.giftMoney.substring(0, 7)
			} else {
				this.giftMoney = this.giftMoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		methodChange () {
			this.percentValue = ''
		},
		muitlSet () {
			if (this.prepaymentdefaultaccount !== 0) {
				this.tipModel = true
				return false
			}
			if (this.ids.length === 0) {
				this.$message.warning('未勾选需要处理的数据，请勾选')
				return false
			}
			this.dialogVisible = true
		},
		multiSave () {
			if (!this.percentValue) {
				this.$message.error('请先填写当前固定充值金额！')
				return false
			}
			// if (+this.percentValue === 0) {
			// 	this.$message.error('预付货款金额不可为0！')
			// 	return false
			// }
			const h = this.$createElement
			const that = this
			this.$msgbox({
				title: '确认充值？',
				message: h('div', null, [
					h('div', { style: 'padding-left:20px;font-size: 20px' }, '￥' + that.percentValue),
					h('div', { style: 'padding-left:20px' }, '充值后不可取消或修改')
				]),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {
					money: +this.percentValue,
					giftMoney: +this.giftMoney,
					customerids: this.ids
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/prepayment/batchadd`,
					data: params
				}).then(res => {
					if (res.result) {
						this.percentValue = ''
						this.giftMoney = '0'
						this.dialogVisible = false
						this.$message.success('充值成功！')
						this.$emit('modifySuc')
					} else {
						this.$message.error('处理失败，请稍后重试！')
					}
				})
			})
		},
		close () {
			this.dialogVisible = false
		},
		goDetail () {
			window.sessionStorage.removeItem('percentageId')
			this.$router.push(`/main/percentageDetail`)
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		search () {
			if (+this.minmoney < 0 || +this.minmoney > 9999999.99 || +this.maxmoney < 0 || +this.maxmoney > 9999999.99) {
				this.$message.error('请设置0~9999999.99范围内的预付货款数值查询！')
				return false
			}
			if (+this.minmoney > +this.maxmoney) {
				this.$message.error('请设置正确的预付货款数值区间！')
				return false
			}
			this.$emit('handleSearch', { customerlevelid: this.customerlevelid, customercategoryid: this.customercategoryid, disabledflag: this.disabledflag, keyword: this.keyword, minmoney: this.minmoney, maxmoney: this.maxmoney, premoneytype: this.premoneytype })
		},
		clear () {
			this.customerlevelid = '0'
			this.customercategoryid = '0'
			this.disabledflag = ''
			this.keyword = ''
			this.minmoney = ''
			this.maxmoney = ''
			this.premoneytype = 0
			this.search()
		},
		fixedAmountRecharge () {
			this.fixedAmountDialogVisible = true
			this.getFixedAmount()
		},
		closeAmountDialog () {
			this.amountList = [
				{
					amount: '',
					giftAmount: '',
					canDelete: false,
					checked: false
				}
			]
			this.isFixedAmountFlag = false
			this.fixedAmountDialogVisible = false
		},
		getFixedAmount () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/premoney/getFixedAmount`
			}).then(res => {
				if (res.result) {
					this.isFixedAmountFlag = res.data.premoneyfixedamountflag
					this.amountList = this.isFixedAmountFlag ? JSON.parse(res.data.premoneyfixedamount) : this.amountList
					if (this.amountList.length === 6) {
						this.disabledAddFlag = true
					} else {
						this.disabledAddFlag = false
					}
					// console.log(this.amountList)
					let amountArr = []
					let giftAmountArr = []
					let amountArr2 = []
					this.amountList.forEach(item => {
						amountArr2 = item.amount.split('-')
						item.amount = amountArr2[0]
						if (amountArr2[1]) {
							this.$set(item, 'giftAmount', amountArr2[1])
						} else {
							this.$set(item, 'giftAmount', '')
						}
						// item.giftAmount = amountArr2[1]
						amountArr.push(item.amount)
						giftAmountArr.push(item.giftAmount)
					})
					this.ruleForm.amount = amountArr.join('、')
					this.ruleForm.giftAmount = giftAmountArr.join('、')
					this.ruleForm.isFixedAmountFlag = this.isFixedAmountFlag
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		saveAmountSetting () {
			if (this.isFixedAmountFlag) {
				if (this.checkAmountRowIsRepeat()) {
					this.$message.error('固定充值金额重复！请核实')
					return false
				}
				if (this.checkAmountRowIsEmpty()) {
					this.$message.error('请先填写当前固定充值金额！')
					return false
				}
				if (this.checkAmountRowIsZero()) {
					this.$message.error('预付货款金额不可为0！')
					return false
				}
			}
			this.amountList.forEach(item => {
				item.amount = item.giftAmount === '' || item.giftAmount === 0 ? item.amount : `${item.amount}-${item.giftAmount}`
				delete item.giftAmount
			})
			// console.log(this.amountList)
			let premoneyfixedamount = this.isFixedAmountFlag ? JSON.stringify(this.amountList) : ''
			let params = {
				premoneyfixedamountflag: this.isFixedAmountFlag,
				premoneyfixedamount
			}
			let amountArr = []
			let giftAmountArr = []
			this.amountList.forEach(item => {
				amountArr.push(item.amount.split('-')[0])
				giftAmountArr.push(item.amount.split('-')[1])
			})
			this.ruleForm.amount = amountArr.join('、')
			this.ruleForm.giftAmount = giftAmountArr.join('、')
			this.ruleForm.isFixedAmountFlag = this.isFixedAmountFlag
			const logger = this.$fxLogger.createInfo('payCenter.pay-advance.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/premoney/setFixedAmount`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.fixedAmountDialogVisible = false
					this.amountList = [
						{
							amount: '',
							giftAmount: '',
							canDelete: false,
							checked: false
						}
					]
					this.$message.success('保存成功！')
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		checkNum (item, index) {
			this.amountList[index].amount = this.amountList[index].amount.replace(/[^0-9.]/g, '')
			this.amountList[index].amount = this.amountList[index].amount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.amountList[index].amount = this.amountList[index].amount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.amountList[index].amount = this.amountList[index].amount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.amountList[index].amount = this.amountList[index].amount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.amountList[index].amount = this.amountList[index].amount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
			if (+this.amountList[index].amount >= 10000000) {
				this.amountList[index].amount = this.amountList[index].amount.substring(0, 7)
			} else {
				this.amountList[index].amount = this.amountList[index].amount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
			// console.log(this.amountList)
		},
		checkNum2 (item, index) {
			this.amountList[index].giftAmount = this.amountList[index].giftAmount.replace(/[^0-9.]/g, '')
			this.amountList[index].giftAmount = this.amountList[index].giftAmount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.amountList[index].giftAmount = this.amountList[index].giftAmount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.amountList[index].giftAmount = this.amountList[index].giftAmount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.amountList[index].giftAmount = this.amountList[index].giftAmount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.amountList[index].giftAmount = this.amountList[index].giftAmount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
			if (+this.amountList[index].giftAmount >= 10000000) {
				this.amountList[index].giftAmount = this.amountList[index].giftAmount.substring(0, 7)
			} else {
				this.amountList[index].giftAmount = this.amountList[index].giftAmount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
			// console.log(this.amountList)
		},
		checkAmountRowIsEmpty () {
			let flag = this.amountList.some(item => { return item.amount === '' })
			return flag
		},
		checkAmountRowIsZero () {
			let flag = this.amountList.some(item => { return item.amount === '0' })
			return flag
		},
		checkAmountRowIsRepeat () {
			let flag
			this.amountArr = []
			this.amountList.forEach(item => {
				this.amountArr.push(item.amount)
			})
			if (new Set(this.amountArr).size !== this.amountList.length) {
				flag = true
			} else {
				flag = false
			}
			// console.log(new Set(this.amountArr).size, this.amountList.length)
			return flag
		},
		addMount () {
			if (this.checkAmountRowIsEmpty()) {
				this.$message.error('请先填写当前固定充值金额！')
				return false
			}
			if (this.checkAmountRowIsZero()) {
				this.$message.error('预付货款金额不可为0！')
				return false
			}
			let item = {
				amount: '',
				giftAmount: '',
				canDelete: true,
				checked: false
			}
			this.amountList.push(item)
			if (this.amountList.length === 6) {
				this.disabledAddFlag = true
			}
		},
		deleteMount (index) {
			this.amountList.splice(index, 1)
			if (this.amountList.length < 6) {
				this.disabledAddFlag = false
			}
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/prepayListExport/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			this.excelParams = {
				customerlevelid: this.customerlevelid,
				customercategoryid: this.customercategoryid,
				disabledflag: this.disabledflag,
				keywordToPreMoney: this.keyword,
				minmoney: +this.minmoney > +this.maxmoney ? '' : this.minmoney,
				maxmoney: +this.minmoney > +this.maxmoney ? '' : this.maxmoney,
				premoneytype: this.premoneytype,
				orderSort: this.orderBy,
				orderby: this.orderKey
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			a.download = this.getFormName()
			a.href = blobUrl
			a.click()
		},
		// 前端导出
		exportExcelByfront () {
			let excelCol = this.$fxUtils.deepClone(this.excelCol)
			if (this.showgift !== 1) {
				excelCol = excelCol.slice(0, 6)
			}
			let excelData = this.$fxUtils.deepClone(this.tableData)
			excelData.forEach(item => {
				item.disabledflag = item.disabledflag ? '停用中' : '启用中'
			})
			this.$fxExcel.exportExcel({
				excelTitle: this.getFormName(),
				excelCol,
				excelData,
				excelSumCol: {}
			})
		},
		getFormName () {
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			return '客户预付货款合计(导出' + year + month + day + hour + min + ').xls'
		}
	}
}
</script>

<style lang="stylus" scoped>
.a-btn {
	cursor: pointer;
	color: #409EFF;
	font-size: 12px;
	text-decoration: underline;
	margin-left: 10px;
	display: inline-block;
	width: 60px;
	height: 40px;
}
.row-box {
	display: flex;
	align-items: center;
}
.search-btn-box{
	padding-top: 5px;
	display:flex;
	justify-content: space-between;
	height:60px;
	align-items: center
}
.advance-search {
	margin-top: 10px;
	display:flex;
	justify-content: space-between;
	width :100%;
	line-height :50px;
}
.advance-search-btn {
	width: 150px;
	flex-shrink: 0
}
.filters-box-row {
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box
	text-align: left
	.search-input {
		width: 240px!important;
	}
	.select-input {
		width: 150px!important;
	}
	.input-title {
		display: inline-block;
		text-indent: 1em
	}
	.filters-container {
		display: flex
		flex-wrap: wrap
		.input-box {
			margin-right: 5px
		}
		.money-box {
			display: inline-block;
			line-height: 32px;
			// border: 1px solid #ebeef5;
			border-radius: 4px;
		}
		.el-input__inner {
			border: 0;
		}
	}
	&.filters-box-row3 {
		padding-top: 5px;
		// border-bottom: 1px solid #dce1fe;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 150px
		}
		.filter-input {
			width: 150px
		}
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 10px;
			display: inline-block;
			width: 60px;
			height: 40px;
			// position: absolute;
			// left: 10px;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			vertical-align: sub;
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
}
.amount-box {
	min-height: 500px;
	.long-span-box {
		display: inline-block;
		width: 250px;
	}
	.content {
		padding: 20px 0px;
    margin: 16px 0;
    display: flex;
    flex-flow: row;
    align-items: center;
    position: relative;
    background: #FFFFFF;
		box-shadow: 0px -2px 15px 1px rgba(62, 62, 62, 0.06);
    border-radius: 6px;
	}
	.el-icon-remove {
		cursor: pointer;
    position: absolute;
    right: -10px;
    bottom: 60px;
    font-size: 18px;
    font-weight: bold;
    color: var(--fx-primary-color);
	}
	.add-btn {
		cursor: pointer;
		display: flex;
    align-items: center;
    justify-content: center;
		width: 100%;
    height: 56px;
    background: #FFFFFF;
    border: 2px dashed var(--fx-primary-color);
    border-radius: 6px;
		font-size: 14px;
		color: var(--fx-primary-color);
	}
}
.batch-dialog {
	padding: 20px 8px 10px;
	.batch-row {
		display: flex;
		align-items: center;
		margin-bottom: 26px;
		font-size: 14px;
		color: #333;
		.batch-label {
			width: 88px;
			text-align: right;
			margin-right: 10px;
			flex-shrink: 0;
		}
		.batch-link {
			color: #409EFF;
			cursor: pointer;
			font-weight: 500;
		}
		.batch-file-name {
			margin-left: 16px;
			color: #303133;
		}
	}
	.batch-footer {
		display: flex;
		justify-content: flex-end;
		margin-top: 44px;
		.btn {
			min-width: 90px;
			margin-left: 12px;
		}
	}
}
</style>
<style lang="stylus">
.tip-modal{
	.el-dialog__body {
		padding: 10px 20px
	}
	.el-dialog__header{
		text-align: left
	}
	.el-dialog__footer{
		text-align:center
	}
}
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.filters-box-row2 {
		.money-box {
			.el-input__inner {
				border: 0;
				text-align: center;
			}
		}
	}
	.dialog-charge-content {
		color: #333;
		&>div {
			margin-bottom: 15px;
			display: flex;
			align-items: center;
		}
		.dialog-name {
			display: inline-block;
			width: 100px;
			text-align: right;
			margin-right: 10px;
			flex-shrink: 0
		}
		.dialog-readonly {
			width: 263px;
			height: 32px;
			line-height: 32px;
			text-indent: 10px;
			background: #F2F2F2;
			border: 1px solid #DBDBDB;
			border-radius: 4px;
		}
		.per-money {
			position: relative
			margin-right: 5px;
			.per-tag {
				position: absolute
				left: 1px
				top: 1px
				bottom: 1px;
				width: 40px;
				z-index: 9;
				display: flex;
				border-top-left-radius: 4px;
				border-bottom-left-radius: 4px;
				align-items: center;
				justify-content: center;
				background-color: #eee;
			}
			.per-input {
				width: 265px
				input {
					text-indent: 35px
				}
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
